import requestReducer from './store/profile-reducer';

export default {
  reducer: requestReducer,
};
